var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MiniTooltip } from "../components/miniTooltip/MiniTooltip";
import * as React from "react";
var MiniTooltipStep = /** @class */ (function (_super) {
    __extends(MiniTooltipStep, _super);
    function MiniTooltipStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MiniTooltipStep.prototype.render = function () {
        var _a = this.props, onNext = _a.onNext, onClose = _a.onClose, allowedPositions = _a.allowedPositions, anchorElement = _a.anchorElement, triggers = _a.triggers, render = _a.render, width = _a.width, onSkip = _a.onSkip, onContinue = _a.onContinue;
        return (React.createElement(MiniTooltip, { anchorElement: anchorElement, triggers: triggers, render: render, allowedPositions: allowedPositions || ["bottom center"], onClose: onClose, onContinue: onContinue, onTargetClicked: onNext, onSkip: onSkip, width: width }));
    };
    return MiniTooltipStep;
}(React.Component));
export { MiniTooltipStep };
